import { IoWarning } from "react-icons/io5";
import { MdOutlineRefresh } from "react-icons/md";
import { useNavigate } from "react-router-dom";

let LoginFailure = () => {
  let navigate = useNavigate();
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <div className="w-[554px] h-[339px] flex flex-col items-center justify-evenly">
        <IoWarning className="text-[#D4640E] w-[70px] h-[60px]" />
        <p className="text-[#35424D] font-semibold text-[25px]">
          Access Restricted
        </p>
        <p className="text-[#5D6871] text-[16px] font-medium">
          Your email is not associated with this application.
        </p>
        <p className="text-[#5D6871] text-[16px] font-medium">
          Please contact your admin to resolve this.
        </p>
        <button
          className="bg-[#1C40C9] text-white w-[140px] h-[32px] flex justify-center items-center rounded-md"
          onClick={() => navigate("/login")}
        >
          <MdOutlineRefresh className="w-5 h-5 mr-1" />
          Retry Login
        </button>
      </div>
    </div>
  );
};

export { LoginFailure };
